import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../../_helper/SharedData";
import {
    showAlert,
} from "../../../Services/Shared.service";
import { Breadcrumbs, Btn, CommonModal, H6 } from "../../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { Plus } from "react-feather";
import UnavailableCarTable from "./UnavailableCarTable";
import { getUnavailableCarsList, getUnavailableCarsListBySearch } from "../../../Services/Car.service";
import SearchTable from "../../Common/Component/SearchTable";
const UnavailableCar = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    const fetchTableData = () => {
        const serviceCityId = globalCityField.value?.id || "All";
        if (!searchData) {
            let obj = {
                serviceCityId: serviceCityId,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getUnavailableCarsList(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (searchData && filterType == "search") {
            let obj = {
                serviceCityId: serviceCityId,
                carNo: searchData,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getUnavailableCarsListBySearch(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        }
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    useEffect(() => {
        if (!searchData && filterType != "search") return;
        setPagination(0)
        fetchTableData();
    }, [searchData]);

    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Packages"
                mainTitle="Packages"
            //   span1={
            //     <FilterTable
            //       options={columns}
            //       setFilterData={setFilterData}
            //       filterData={filterData}
            //       setSearchData={setSearchData}
            //       setFilterType={setFilterType}
            //       statusData={bookingStatusData}
            //       bookingViaTypeData={bookingViaTypeData}
            //     />
            //   }
            span3={
                <SearchTable
                    searchData={searchData}
                    setSearchData={setSearchData}
                    setFilterData={setFilterData}
                    setFilterType={setFilterType}
                />
            }
            />
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <UnavailableCarTable
                                    fetchTableData={fetchTableData}
                                    tableData={tableData}
                                    setShowApiLoader={setLoader}
                                    onChangePage={onChangePage}
                                    paginationPerPage={rowsPerPage}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    loader={loader}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default UnavailableCar;
